import { useContext, useEffect } from "react";
import Styles from "./Styles/VerifyPayment.module.css";

import { Link } from "react-router-dom";
import { updateUser } from "../../../../Services/usersService";
import { AuthContext } from "../../../../Context/AuthContext";
import toast, { Toaster } from "react-hot-toast";

const VerifyPayment = () => {
  const { login } = useContext(AuthContext);

  useEffect(() => {
    const updateUserToken = async () => {
      try {
        const { data } = await updateUser();
        login(data.token);
      } catch (ex) {
        toast.error(ex.response.data.message);
      }
    };
    updateUserToken();
  }, []);

  return (
    <div className={Styles.container}>
      <Toaster />
      <h2>پرداخت شما موفقیت آمیز بود</h2>
      <Link to="/">صفحه اصلی</Link>
    </div>
  );
};

export default VerifyPayment;
